import { Field, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { FiftyFiftyElement } from '../../components/FiftyFiftyElement';
import { howOften, when_Automated } from '../../constants';
import { EVO } from '../../EVO';
import './NotificationChoreDetails.css';
import { Question } from './Question';
import { PTErrors } from '../../components/PTElements';

export const NcdStep5 = () => {
    const [howOftenVals, setHowOftenVals] = useState(EVO.getSelectItemFromObjectOfSelectItems(howOften));
    const { values } = useFormikContext();

    useEffect(() => {
        if (values.whenAutomatedId === when_Automated.AfterDna.value) {
            const validVals = howOftenVals.filter(a => a.value !== howOften.OnceInADay.value);
            setHowOftenVals(validVals);
        }
    }, []);

    return (
        <div>
            <Question>How often should they receive it?</Question>
            <Field name="howOftenId" component={FiftyFiftyElement} options={howOftenVals}
                placeholder="" center="true" subLabelOnSelect={true} />
            <PTErrors fields={['howOftenId']} />
        </div>       
    );
}


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NcdStep5.js